module.exports = "assets/4e79c976fe3022d9bacd75d6e5331416.glb";